module.exports = __webpack_public_path__ + "media/temp/game-icon-b1f89f92.png";